import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  ResponsiveContainer, LineChart, Line, BarChart, Bar,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ComposedChart
} from 'recharts';

const ClimateChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get('https://sense-agro-backend.onrender.com/api/leituras-diarias')
      .then(res => {
        const formatado = res.data.map(item => ({
          dia: item.data,
          temperatura: item.temperatura,
          chuva: Math.floor(Math.random() * 30), // valor simulado de chuva
        }));
        setData(formatado);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="h-64 bg-slate-800 rounded-xl p-4 text-white">
      <h2 className="text-lg font-semibold mb-3">Variação Climática (7 dias)</h2>
      <ResponsiveContainer width="100%" height="85%">
        <ComposedChart data={data} margin={{ top: 10, right: 20, bottom: 0, left: -10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#475569" />
          <XAxis dataKey="dia" stroke="#94a3b8" />
          <YAxis yAxisId="left" stroke="#f87171" />
          <YAxis yAxisId="right" orientation="right" stroke="#60a5fa" />
          <Tooltip />
          <Legend />
          <Bar yAxisId="right" dataKey="chuva" fill="#60a5fa" name="Chuva (mm)" />
          <Line yAxisId="left" type="monotone" dataKey="temperatura" stroke="#f87171" name="Temperatura (°C)" strokeWidth={3} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ClimateChart;
